import cn from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';
import { ListCard } from 'src/components/ListContent/components/ListCard';

import { BANNER_TYPES } from '@sravni/react-advertisement';
import { Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { AB_NAME } from '../../../../constants/sitesettings';
import { usePartners } from '../../../../hooks/organizations';
import { ListContentLayout } from '../../../Layouts/ListContentLayout';
import { OrgMaterialCard } from '../../../ListCards/OrganizationMaterialCard';
import { ListGrid } from '../../../ListGrid';
import { OrgDialogSelector } from '../../../OrgDialogSelector';
import { ReduxBanner } from '../../../ReduxBanner';
import { ListGroup } from '../../components/ListGroup';
import { createListRenderer } from '../../helpers/createListRenderer';
import { ListContainerProps, withListContainer } from '../../hoc/withListContainer';
import { DateGroupListContainer, getGroupTitle } from '../DateGroupList';

import styles from './styles.module.scss';

interface Props {}

export const PartnersListContainer = (props: Props & ListContainerProps) => {
  const { handleShowAuthPopup, createItemClickHandler } = props;
  const { asPath } = useRouter();
  const orgs = usePartners();
  const isMobile = useIsMobile();

  const banner = <ReduxBanner lazy={true} type={BANNER_TYPES.SIDE} className={styles.sideBanner} abName={AB_NAME} />;
  const injectConfig = isMobile
    ? {
        0: banner && <ListGrid.Cell className="h-mb-24 h-mt-24">{banner}</ListGrid.Cell>,
      }
    : {};

  return (
    <DateGroupListContainer
      {...props}
      heading={
        <ListContentLayout.Heading className={styles.heading}>
          <Typography.Heading level={2}>Новости компаний</Typography.Heading>
          <OrgDialogSelector className={cn(styles['orgs-wrapper'], isMobile ? 'h-mt-4' : 'h-mt-16')} partners={orgs} />
        </ListContentLayout.Heading>
      }
      withImages={false}
      injectConfig={injectConfig}
    >
      {([date, group], groupIdx) => {
        return (
          <>
            <ListGroup title={getGroupTitle(date)}>
              <ListGrid className={styles.group}>
                {createListRenderer(group, (material, index) => {
                  return (
                    <>
                      <ListCard
                        wrapper={ListGrid.Cell}
                        as={'article'}
                        index={index}
                        material={material}
                        // ** такой вид ключа очень важен для корректного отображения статей
                        key={`${material.alias}-${material.id}-${index}-${asPath}`}
                        handleShowAuthPopup={handleShowAuthPopup}
                        titleTag={index === 0 ? 'h1' : 'h2'}
                        size={!isMobile || index === 0 ? 'normal' : 'small'}
                        card={OrgMaterialCard}
                        direction={isMobile ? 'horizontal-reverse' : 'vertical'}
                        withImage={false}
                        onClick={createItemClickHandler(index, material)}
                      />

                      {injectConfig[groupIdx]?.[index]}
                    </>
                  );
                })}
              </ListGrid>
            </ListGroup>
            {/* @ts-ignore */}
            {React.isValidElement(injectConfig[groupIdx]) ? injectConfig[groupIdx] : injectConfig[groupIdx]?.item}
          </>
        );
      }}
    </DateGroupListContainer>
  );
};

export const PartnersList = withListContainer()(PartnersListContainer);
